import React from 'react';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
// material ui
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import EmailIcon from '@material-ui/icons/Email';
import LinkIcon from '@material-ui/icons/Link';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import PhoneIcon from '@material-ui/icons/Phone';
import Typography from '@material-ui/core/Typography';
// components
import Theme from '../../Theme.js';
import WidgetBar from '../../../../builder/components/WidgetBar.js'

const useStyles = makeStyles({
  avatar: {
    backgroundColor: Theme.bgColorDark,
  },
  card: {
    marginBottom: '28px',
    boxShadow: Theme.cardBoxShadow,
    position: 'relative',
  },
  contactDetails: {
    "&:last-child": {
      paddingBottom: "1rem",
    },
  },
  header: {
    backgroundColor: props => props.screen == 'desktop' ? Theme.bgColorDark : '#ffffff',
  },
  headerText: {
    textAlign: 'center',
    fontSize: '1.3rem',
  },
  listItemText: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    margin: "0",
  },
  listItemTextPrimary: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
});

export default function Contact(props) {
  const { context, screen } = props;
  const classes = useStyles(props);
  const [showWidgetBar, setShowWidgetBar] = React.useState(false)
  var order;
  (screen == 'desktop') ? (order = context.desktop_order) : (order = context.mobile_order);
  const componentClasses = clsx({
    [classes.card] : true,
    "cardMobile" : screen == 'mobile' ? true : false,
  })

  let language;
  if (window.mode == 'live') {
    language = window.language;
  } else {
    language = useSelector(state => state.language);
  };


  const handleWidgetHover = (e) => {
    if (e.type == 'mouseenter') {
      setShowWidgetBar(true);
    } else if (e.type == 'mouseleave') {
      setShowWidgetBar(false);
    }
  }
  
  return (
    <Card className={componentClasses + ' contact-widget'} style={{ order: order }}
      onMouseEnter={window.mode == 'builder' ? handleWidgetHover : null} onMouseLeave={window.mode == 'builder' ? handleWidgetHover : null}
    >
      <CardContent className={classes.header} >
        <Typography variant="h5" component="h2" className={classes.headerText} >
          {context.header_text[language]}
        </Typography>
      </CardContent>
      <CardContent classes={{ root: classes.contactDetails }} >
        <List disablePadding >

          {context.show_email &&
            <ListItem disableGutters >
              <ListItemAvatar >
                <Avatar className={classes.avatar}>
                  <EmailIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={context.email} classes={{ root: classes.listItemText}} />
            </ListItem>
          }
          {context.show_phone &&
          <ListItem disableGutters >
            <ListItemAvatar >
              <Avatar className={classes.avatar}>
                <PhoneIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={context.phone} classes={{ root: classes.listItemText}} />
          </ListItem>
          }
          {context.show_link &&
          <ListItem disableGutters >
            <ListItemAvatar >
              <Avatar className={classes.avatar}>
                <LinkIcon />
              </Avatar>
            </ListItemAvatar>
            <a href={context.website.includes('http') ? context.website : "#"} target={context.website.includes('http') ? "_blank" : "_self"}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
              }}
            >
              <ListItemText primary={context.website} classes={{ root: classes.listItemText, primary: classes.listItemTextPrimary }} />
            </a>
          </ListItem>
          }
          {context.show_address &&
          <ListItem disableGutters alignItems="flex-start">
            <ListItemAvatar style={{ marginTop: "0" }}>
              <Avatar className={classes.avatar}>
                <LocationOnIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={
              <>
                <span style={{ display: "block" }}>{context.address_1}</span>
                <span style={{ display: "block" }}>{context.address_2}</span>
                <span style={{ display: "block" }}>{context.address_3}</span>
              </>
            } classes={{ root: classes.listItemText}} />
          </ListItem>
          }

        </List>
      </CardContent>

      {window.mode == 'builder' && showWidgetBar &&
        <WidgetBar context={context} />
      }

    </Card>
  );
}

